export enum AppType {
  FORM,
  DATA_REQUEST,
}
